import { render, staticRenderFns } from "./MappingDetail.vue?vue&type=template&id=680a00e8&scoped=true&"
import script from "./MappingDetail.vue?vue&type=script&lang=js&"
export * from "./MappingDetail.vue?vue&type=script&lang=js&"
import style0 from "./MappingDetail.vue?vue&type=style&index=0&id=680a00e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680a00e8",
  null
  
)

export default component.exports